import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import Text from './Text';

const LinkRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const StyledLink = styled(Link)`
  border-radius: 50%;
  transition: border ease-out 0.2s;
  display: inline-flex;
  align-items: center;
  transition: opacity ease-out 0.2s;
  svg {
    margin-right: 12px;
  }
  &:hover,
  &:active {
    opacity: 0.8;
  }
`;

interface Props {
  link?: string;
  className?: string;
  onClick?: VoidFunction;
}

const BackButton: FC<Props> = ({ link, className, onClick }) => {
  const navigate = useNavigate();

  return (
    <LinkRow className={className}>
      <StyledLink
        to={link ?? ''}
        onClick={(e) => {
          if (onClick) {
            e.preventDefault();
            return onClick();
          }

          if (!link) {
            e.preventDefault();
            navigate(-1);
          }
        }}
        relative="path"
      >
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 33C8.16344 33 1 25.8366 1 17C1 8.16344 8.16344 1 17 1C25.8366 1 33 8.16344 33 17C33 25.8366 25.8366 33 17 33Z"
            stroke="#E9E9E9"
            strokeMiterlimit="10"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.4288 12.2821C15.8253 11.8976 16.4584 11.9073 16.8429 12.3038C17.2274 12.7003 17.2177 13.3334 16.8212 13.7179L14.468 16H23C23.5523 16 24 16.4477 24 17C24 17.5523 23.5523 18 23 18H14.468L16.8212 20.2821C17.2177 20.6666 17.2274 21.2997 16.8429 21.6962C16.4584 22.0927 15.8253 22.1024 15.4288 21.7179L11.3043 17.7179C11.1101 17.5295 11.0005 17.2705 11.0005 17C11.0005 16.7295 11.1101 16.4705 11.3043 16.2821L15.4288 12.2821Z"
            fill="#222222"
          />
        </svg>
        <Text $type="button">Back</Text>
      </StyledLink>
    </LinkRow>
  );
};

export default BackButton;
